import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.object,
  correctAnswerText: PropTypes.string,
};

export const AllCorrectAnswersGraphic = ({ children, correctAnswerText }) => {
  return (
    <svg
      width="194"
      height="128"
      viewBox="0 0 194 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{correctAnswerText}</title>
      <path
        d="M29 88C21.8203 88 16 82.1797 16 75C16 67.8203 21.8203 62 29 62C36.1797 62 42 67.8203 42 75C42 82.1797 36.1797 88 29 88Z"
        fill="#FFEDD1"
      />
      <path
        d="M151 35C143.82 35 138 29.1797 138 22C138 14.8203 143.82 9 151 9C158.18 9 164 14.8203 164 22C164 29.1797 158.18 35 151 35Z"
        fill="#FFEDD1"
      />
      <path
        d="M184 55C178.477 55 174 50.5228 174 45C174 39.4772 178.477 35 184 35C189.523 35 194 39.4772 194 45C194 50.5228 189.523 55 184 55Z"
        fill="#FFB746"
      />
      <path
        d="M6.5 68C2.91015 68 0 65.0899 0 61.5C0 57.9101 2.91015 55 6.5 55C10.0899 55 13 57.9101 13 61.5C13 65.0899 10.0899 68 6.5 68Z"
        fill="#FFB746"
      />
      <path
        d="M175 77C172.791 77 171 75.2091 171 73C171 70.7909 172.791 69 175 69C177.209 69 179 70.7909 179 73C179 75.2091 177.209 77 175 77Z"
        fill="#DF9C2B"
      />
      <path
        d="M25.5 48C23.567 48 22 46.433 22 44.5C22 42.567 23.567 41 25.5 41C27.433 41 29 42.567 29 44.5C29 46.433 27.433 48 25.5 48Z"
        fill="#FFEDD1"
      />
      <path
        d="M11 34C11 34 14.5 32.5 15 32C15.5 31.5 17 28 17 28C17 28 18.5 31.5 19 32C19.5 32.5 23 34 23 34C23 34 19.5 36.1667 19 36.6667C18.5 37.1667 17 40 17 40C17 40 15.5 37.1667 15 36.6667C14.5 36.1667 11 34 11 34Z"
        fill="#DF9C2B"
        stroke="#DF9C2B"
        strokeLinejoin="round"
      />
      <path
        d="M170 19.5C170 19.5 172.042 18.625 172.333 18.3333C172.625 18.0417 173.5 16 173.5 16C173.5 16 174.375 18.0417 174.667 18.3333C174.958 18.625 177 19.5 177 19.5C177 19.5 174.958 20.7639 174.667 21.0556C174.375 21.3472 173.5 23 173.5 23C173.5 23 172.625 21.3472 172.333 21.0556C172.042 20.7639 170 19.5 170 19.5Z"
        stroke="#DF9C2B"
        strokeLinejoin="round"
      />
      <path
        d="M163 54.5C163 54.5 165.042 53.625 165.333 53.3333C165.625 53.0417 166.5 51 166.5 51C166.5 51 167.375 53.0417 167.667 53.3333C167.958 53.625 170 54.5 170 54.5C170 54.5 167.958 55.7639 167.667 56.0556C167.375 56.3472 166.5 58 166.5 58C166.5 58 165.625 56.3472 165.333 56.0556C165.042 55.7639 163 54.5 163 54.5Z"
        fill="#DF9C2B"
        stroke="#DF9C2B"
        strokeLinejoin="round"
      />
      <path
        d="M4 94.5C4 94.5 6.04167 93.625 6.33333 93.3333C6.625 93.0417 7.5 91 7.5 91C7.5 91 8.375 93.0417 8.66667 93.3333C8.95833 93.625 11 94.5 11 94.5C11 94.5 8.95833 95.7639 8.66667 96.0556C8.375 96.3472 7.5 98 7.5 98C7.5 98 6.625 96.3472 6.33333 96.0556C6.04167 95.7639 4 94.5 4 94.5Z"
        stroke="#DF9C2B"
        strokeLinejoin="round"
      />
      <path
        d="M91.8217 2.36472C94.9507 -0.78824 100.049 -0.78824 103.178 2.36472L105.626 4.83158C107.868 7.08997 111.234 7.80547 114.2 6.65397L117.44 5.39614C121.581 3.78846 126.239 5.86225 127.815 10.0154L129.048 13.2647C130.177 16.2394 132.961 18.2624 136.139 18.4168L139.611 18.5854C144.047 18.801 147.459 22.59 147.21 27.0251L147.015 30.4951C146.836 33.6718 148.557 36.6524 151.397 38.086L154.5 39.652C158.465 41.6536 160.041 46.5027 158.009 50.4529L156.42 53.5435C154.964 56.3729 155.324 59.7957 157.336 62.2608L159.533 64.9533C162.342 68.3948 161.809 73.4655 158.346 76.2478L155.637 78.4247C153.157 80.4176 152.093 83.6908 152.928 86.7609L153.841 90.1145C155.007 94.4008 152.457 98.816 148.162 99.95L144.802 100.836C141.726 101.648 139.423 104.206 138.937 107.35L138.406 110.785C137.728 115.175 133.603 118.172 129.218 117.46L125.788 116.904C122.647 116.394 119.503 117.794 117.78 120.469L115.899 123.391C113.494 127.125 108.506 128.185 104.79 125.752L101.883 123.848C99.2207 122.105 95.7787 122.105 93.1167 123.848L90.2097 125.752C86.4933 128.185 81.5062 127.125 79.1011 123.391L77.2193 120.469C75.4966 117.794 72.3524 116.394 69.2118 116.904L65.7812 117.46C61.3965 118.172 57.2718 115.175 56.5936 110.785L56.063 107.35C55.5772 104.206 53.2743 101.648 50.1978 100.836L46.8373 99.95C42.5423 98.816 39.9931 94.4008 41.1591 90.1145L42.0714 86.7609C42.9066 83.6908 41.8429 80.4176 39.3627 78.4247L36.6535 76.2478C33.1908 73.4655 32.6577 68.3948 35.4663 64.9533L37.6638 62.2608C39.6755 59.7957 40.0352 56.3729 38.58 53.5435L36.9904 50.4529C34.9587 46.5027 36.5342 41.6536 40.4998 39.652L43.6024 38.086C46.4428 36.6524 48.1637 33.6718 47.9851 30.4951L47.79 27.0251C47.5406 22.59 50.9522 18.801 55.3891 18.5854L58.8605 18.4168C62.0385 18.2624 64.8229 16.2394 65.9518 13.2647L67.1848 10.0154C68.7609 5.86225 73.4187 3.78846 77.5597 5.39614L80.7995 6.65397C83.7655 7.80547 87.132 7.08997 89.3732 4.83158L91.8217 2.36472Z"
        fill="#FFB746"
      />
      <path
        d="M98 113C125.062 113 147 91.062 147 64C147 36.938 125.062 15 98 15C70.938 15 49 36.938 49 64C49 91.062 70.938 113 98 113Z"
        fill="#FFEDD1"
        stroke="white"
        strokeWidth="2"
      />
      {children}
    </svg>
  );
};

AllCorrectAnswersGraphic.propTypes = propTypes;
